/**
 * Maps report type enum values to i18n keys.
 */
export const REPORT_TYPE_KEYS: Record<string, string> = {
  harassment: 'reports.type_harassment',
  spam: 'reports.type_spam',
  inappropriate: 'reports.type_inappropriate',
  violence: 'reports.type_violence',
  other: 'reports.type_other',
};

/**
 * Maps Flutter app report reason values to i18n keys.
 * Covers:
 * - Report message: mainOptions + bullyingOptions
 * - Report chat: _chatMainOptions + _chatBullyingOptions
 */
export const REPORT_REASON_KEYS: Record<string, string> = {
  // === Report Message: mainOptions ===
  bullyingHarassmentAbuse: 'reports.reason_bullying_harassment',
  violentContent: 'reports.reason_violent_content',
  suicideSelfHarm: 'reports.reason_suicide_self_harm',
  restrictedItems: 'reports.reason_restricted_items',
  adultContent: 'reports.reason_adult_content',
  scamsFraud: 'reports.reason_scams_fraud',
  otherReason: 'reports.reason_other',

  // === Report Message: bullyingOptions ===
  threateningNudes: 'reports.reason_threatening_nudes',
  sexualExploitation: 'reports.reason_sexual_exploitation',
  humanTrafficking: 'reports.reason_human_trafficking',
  bullyingHarassment: 'reports.reason_bullying',

  // === Report Chat: _chatMainOptions (prefixed with reportChat) ===
  reportChatBullyingHarassmentAbuse: 'reports.reason_bullying_harassment',
  reportChatRestrictedItems: 'reports.reason_restricted_items',

  // === Report Chat: _chatBullyingOptions (prefixed with reportChat) ===
  reportChatThreateningNudes: 'reports.reason_threatening_nudes',
};

/**
 * Returns the translated label for a report reason value.
 * Falls back to the raw value if no mapping exists.
 */
export const getReasonLabel = (
  reason: string,
  t: (key: string) => string,
): string => {
  const key = REPORT_REASON_KEYS[reason];

  if (key) {
    const translated = t(key);
    return translated !== key ? translated : reason;
  }

  return reason;
};

/**
 * Returns the translated label for a report type value.
 */
export const getTypeLabel = (
  type: string,
  t: (key: string) => string,
): string => {
  const key = REPORT_TYPE_KEYS[type] || REPORT_TYPE_KEYS.other;
  const translated = t(key);
  return translated !== key ? translated : type;
};
